import { Wrapper } from './PreQueueTab.styles'
import { actions } from '../../SupplierState'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { PreQueueTable } from '../PreQueueTable/PreQueueTable'
import { PreQueueDeletedItemsTable } from '../preQueueDeletedItemsTable/PreQueueDeletedItemsTable'

export const PreQueueTab = () => {
  const { fc } = useFulfillmentCenter()
  const dispatch = useDispatch()

  useEffect(() => {
    const refreshData = () => {
      dispatch(actions.getPreQueue({ fcId: fc.id }))
    }

    refreshData()

    const interval = setInterval(refreshData, 120000)

    return () => {
      clearInterval(interval)
    }
  }, [dispatch, fc])

  return (
    <Wrapper>
      <PreQueueTable />
      <PreQueueDeletedItemsTable />
    </Wrapper>
  )
}
